import request from "root/js/request";

export const getParsersSubjects = async ({
  search,
  id__in,
  limit = 100,
  offset = 0,
  ...rest
} = {}) => {
  const response = await request({
    url: `parsers/subjects/`,
    method: "get",
    params: {
      search: search || undefined,
      id__in: id__in || undefined,
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
